export default "__VITE_ASSET__Dxabymjn__"